module.exports = __webpack_public_path__ + "static/media/YM58_0.8a07593b.jpg";